<template>
  <div>
    <div v-if="projectMetrics.length > 0">
      <b-table
        responsive
        :items="projectMetrics"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :fields="fields"
        class="action-items"
        @row-clicked="launchProjectMetric"
      >
        <template #cell()="data">
          <span v-if="data.value == ''">--</span>
          <span v-else>{{ data.value }}</span>
        </template>
        <template v-slot:cell(name)="data">
          <b-link @click="viewProjectMetric(data.item.projectMetricId)">{{
            data.item.name
          }}</b-link>        
        </template>
        <template v-slot:cell(champion)="data">
          <div :class="{'text-danger':  data.item.overDue }">
            <span v-if="data.item.assignedToUsers.length == 0">--</span>
            <span v-else>{{
              data.item.assignedToUsers.map((u) => u.name).join(", ")
            }}</span>
          </div>
        </template>
        <template v-slot:cell(daysOpen)="data">
          <div :class="{'text-danger': data.item.overDue }">
            {{ data.item.daysOpen }}
          </div>
        </template>
        <template v-slot:cell(identifiedByRole)="data">
          <div :class="{'text-danger':  data.item.overDue }">
            {{ data.item.identifiedByRole }}
          </div>
        </template>
        <template v-slot:cell(comments)="data">
          <div :class="{'text-danger':  data.item.overDue }">
            {{ data.item.comments.length }}
          </div>
        </template>
        <template v-slot:cell(status)="data">
          <div class="lvl">
            <span style="max-width: 90px">{{ data.item.status }}</span>
          </div>
        </template>
        <template v-slot:cell(type)="data">
          <div class="lvl">
            <span style="max-width: 90px">{{ data.item.type }}</span>
          </div>
        </template>
      </b-table>
      
      <ViewProjectMetricModal
        ref="view-project-metric-modal"
        :projectMetric="viewingProjectMetric"
        @refresh="refreshProjectMetric"
      ></ViewProjectMetricModal>

      <EditProjectMetricModal
        ref="edit-project-metric-modal"
        :projectId="viewingProjectMetric ? viewingProjectMetric.projectId : ''"
        :projectMetric="viewingProjectMetric"
        :possibleAssignees="possibleAssignees"
        @submit="refreshProjectMetric">
      </EditProjectMetricModal>
    </div>
    <div v-else>Nothing to report</div>
  </div>
</template>

<script>
import ViewProjectMetricModal from "@/components/modals/ViewProjectMetricModal.vue";
import EditProjectMetricModal from "@/components/modals/EditProjectMetricModal.vue";

export default {
  name: "ProjectMetricActions",
  props: {
    projectMetrics: { type: Array, default: () => [] },
    possibleAssignees: { type: Array, default: () => [] },
    //isOverdue : {type: Boolean, default: false}
  },
  components: {
    ViewProjectMetricModal,
    EditProjectMetricModal
  },
  data() {
    return {
      viewingProjectMetricId: "",
      fields: [
        {
          key: "type",
          label: "",
          tdClass: (value) => value.toLowerCase().replace(/ /g, "-"),
          thClass: "skinny-col",
        },
        { key: "name", label: "", tdClass: "meta-header" },
        { key: "champion", label: "Champion", tdClass: "data" },
        { key: "identifiedByRole", label: "Who Identified", tdClass: "data", sortable: true },
        { key: "daysOpen", label: "Days Open", tdClass: "data", sortable: true },
        { key: "comments", label: "Comments", tdClass: "data", sortable: true },
        {
          key: "status",
          label: "Status",
          tdClass: (value) => value.toLowerCase().replace(/ /g, "-"),
          thClass: "skinny-col",
        },
      ],
      sortBy: "status",
      sortDesc: true,
      todaysDate: new Date(),
    };
  },
  methods: {
    viewProjectMetric(id) {
      this.viewingProjectMetricId = id;

      this.$nextTick(() => {
        this.$refs["view-project-metric-modal"].show();
      });
    },
    launchProjectMetric() {},
    refreshProjectMetric(id) {
      this.$emit("refresh", id);
      this.$nextTick(() => {
        this.$refs["edit-project-metric-modal"].reset();
        this.$refs["view-project-metric-modal"].reset();
      });
    },
    filter(selection) {
      this.actionsSelection = selection;
    },
  },
  computed: {
    filteredItems() {
      if (this.actionsSelection === "Open") {
        return this.openItems;
      } else return this.projectMetrics;
    },
    openItems() {
      return this.projectMetrics.filter((p) => p.status == "Open");
    },
    viewingProjectMetric() {
      return this.projectMetrics.find(
        (p) => p.projectMetricId === this.viewingProjectMetricId
      );
    },
  },
};
</script>